export default __webpack_public_path__ + "static/media/drivers-application-page-icon.5a31050f.svg";